$(function(){
    console.log('Loaded STUDY')
    if($("#application_cpr_numbers_yes").length) {
        $(".radio").click(check_cpr_numbers_true_selected);
        check_cpr_numbers_true_selected()
    }
});
function check_cpr_numbers_true_selected() {
    if ($("#application_cpr_numbers_yes")[0].checked == true) {
        $("div.application_cpr_numbers_reason").show()
    } else {
        $("div.application_cpr_numbers_reason").hide()
    }
}